<template>
  <div
    class="w-full h-full flex relative bg-grey overflow-hidden"
    style="min-width: 400px; max-width: 400px"
  >
    <div
      class="flex-1 flex flex-col bg-grey max-w-full"
      v-if="data.brand != 'asr'"
    >
      <!-- streetview -->
      <div
        class="w-full bg-grey flex relative justify-center items-center"
        style="aspect-ratio: 1"
        v-if="data.permission != 1"
      >
        No Street View for this coordinate
        <gmap-street-view-panorama
          v-if="data.permission"
          ref="pano"
          :position="{
            lat: data.lat,
            lng: data.lng,
          }"
          :pov="{
            heading: data.heading || 0,
            pitch: 0,
          }"
          :zoom="1"
          class="absolute left-0 top-0 w-full h-full"
        />
      </div>
      <div
        class="flex-1 flex w-full bg-white rounded-t-lg min-h-0"
        style="box-shadow: 2px -4px 15px rgba(0, 0, 0, 0.288)"
      >
        <div class="w-full flex flex-col">
          <div
            class="text-lg font-black truncate py-8 flex justify-between items-center px-4 border-t-0 border-l-0 border-r-0 border-b border-solid border-grey-light"
            style="letter-spacing: 0.5px; max-width: 100%"
          >
            <div class="flex flex-col flex-1">
              <span
                style="font-size: 20px; white-space: normal"
                class="break-words"
              >
                {{ data.assetName }}
              </span>
              <span class="font-semibold text-sm"> {{ data.lastUpdated }}</span>
              <span class="font-light text-xs flex items-center">
                <vs-icon icon="schedule" class="pr-1" />
                Updated</span
              >
            </div>
            <div class="flex flex-col gap-2">
              <vs-button @click="navigateToManageUnit" size="small"
                >Manage</vs-button
              >
              <vs-button @click="$emit('get-unit')" color="success" size="small"
                >Center View</vs-button
              >
            </div>
          </div>
          <!-- scroll -->
          <div
            class="w-full flex flex-1 flex-col overflow-auto min-h-0 px-5 py-6"
          >
            <div class="flex w-full" style="gap: 8px">
              <div
                v-for="(item, i) in widget"
                :key="i"
                class="relative border-solid border flex flex-1 flex-col justify-around items-center px-1 rounded-lg border-grey-light"
                style="aspect-ratio: 1"
              >
                <div
                  class="text-sm font-normal text-left absolute top-0 left-0 my-2 flex items-center"
                  style="height: fit-content"
                >
                  <div class="h-full px-2 flex items-center">
                    <vs-icon
                      :icon-pack="icon[item.label.toLowerCase()].p"
                      :icon="icon[item.label.toLowerCase()].i"
                      style="font-size: 12px"
                    />
                  </div>
                  {{ item.label }}
                </div>
                <div
                  class="text-lg font-bold leading-none tracking-tight"
                  :style="i == 0 ? { color: data.textColor } : void 0"
                >
                  {{ item.data }}
                </div>
              </div>
            </div>
            <div
              v-for="(item, i) in list"
              :key="i"
              class="text-lg font-black flex flex-col justify-between items-start"
              style="letter-spacing: 0.5px"
              :class="[item.label == 'Location' ? 'py-1' : 'py-4 ']"
            >
              <div
                class="w-full flex justify-between"
                :class="[
                  item.label == 'location'
                    ? 'flex-col items-start gap-4'
                    : 'items-center ',
                ]"
              >
                <div class="font-light text-sm flex items-center">
                  <div class="h-full px-2 pr-3 flex items-center">
                    <vs-icon
                      :icon-pack="icon[item.label.toLowerCase()].p"
                      :icon="icon[item.label.toLowerCase()].i"
                      style="font-size: 18px"
                    />
                  </div>
                  <div class="flex flex-col justify-center">
                    <div
                      class="capitalize"
                      :class="{
                        'font-bold text-base': item.label == 'heatmap',
                      }"
                    >
                      {{ item.label }}
                    </div>
                    <div v-if="item.caption" class="text-sm">
                      {{ item.caption }}
                    </div>
                  </div>
                </div>
                <span
                  class="text-sm"
                  :class="[
                    {
                      'text-primary cursor-pointer border-solid border-1 px-3 py-1 rounded-lg hover:bg-grey-light duration-2':
                        item.label == 'fuel' || item.label == 'temp',
                    },
                    {
                      'text-grey pointer-events-none':
                        (fetchFuelData && item.label == 'fuel') ||
                        (fetchFuelData && item.label == 'temp'),
                    },
                    { 'pl-3': item.label == 'location' },
                  ]"
                  @click="action(item.label)"
                >
                  {{
                    (fetchFuelData && item.label == 'fuel') ||
                    (fetchFuelData && item.label == 'temp')
                      ? `fetching data`
                      : item.data
                  }}
                </span>
                <!-- switch -->

                <vs-switch
                  v-model="showHeatmap"
                  size="small"
                  v-if="item.label == 'heatmap'"
                  color="success"
                >
                  <span slot="on">SHOW</span>
                  <span slot="off">HIDE</span>
                </vs-switch>
              </div>
              <div class="w-full mt-3 px-1" style="height: 1px">
                <div class="w-full h-full bg-grey-light"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex-1 flex flex-col bg-grey max-w-full"
      v-if="data.brand == 'asr'"
    >
      <!-- streetview -->
      <div
        class="w-full bg-grey flex relative justify-center items-center"
        style="aspect-ratio: 1"
        v-if="data.permission != 1"
      >
        No Street View for this coordinate
        <gmap-street-view-panorama
          v-if="data.permission"
          ref="pano"
          :position="{
            lat: data.lat,
            lng: data.lng,
          }"
          :pov="{
            heading: data.heading || 0,
            pitch: 0,
          }"
          :zoom="1"
          class="absolute left-0 top-0 w-full h-full"
        />
      </div>
      <div
        class="flex-1 flex w-full bg-white rounded-t-lg min-h-0"
        style="box-shadow: 2px -4px 15px rgba(0, 0, 0, 0.288)"
      >
        <div class="w-full flex flex-col">
          <div
            class="text-lg font-black truncate py-8 flex justify-between items-center px-4 border-t-0 border-l-0 border-r-0 border-b border-solid border-grey-light"
            style="letter-spacing: 0.5px; max-width: 100%"
          >
            <div class="flex flex-col flex-1">
              <span
                style="font-size: 20px; white-space: normal"
                class="break-words"
              >
                {{ data.assetName }}
              </span>
              <span class="font-semibold text-sm"> {{ data.lastUpdated }}</span>
              <span class="font-light text-xs flex items-center">
                <vs-icon icon="schedule" class="pr-1" />
                Updated</span
              >
            </div>
            <div class="flex flex-col gap-2">
              <vs-button @click="navigateToManageUnit" size="small"
                >Manage</vs-button
              >
              <vs-button @click="$emit('get-unit')" color="success" size="small"
                >Center View</vs-button
              >
            </div>
          </div>
          <!-- scroll -->
          <div
            class="w-full flex flex-1 flex-col overflow-auto min-h-0 px-5 py-6"
          >
            <div class="flex w-full" style="gap: 8px">
              <div
                v-for="(item, i) in widget"
                :key="i"
                class="relative border-solid border flex flex-1 flex-col justify-around items-center px-1 rounded-lg border-grey-light"
                style="aspect-ratio: 1"
              >
                <div
                  class="text-sm font-normal text-left absolute top-0 left-0 my-2 flex items-center"
                  style="height: fit-content"
                >
                  <div class="h-full px-2 flex items-center">
                    <vs-icon
                      :icon-pack="icon[item.label.toLowerCase()].p"
                      :icon="icon[item.label.toLowerCase()].i"
                      style="font-size: 12px"
                    />
                  </div>
                  {{ item.label }}
                </div>
                <div
                  class="text-lg font-bold leading-none tracking-tight"
                  :style="i == 0 ? { color: data.textColor } : void 0"
                >
                  {{ item.data }}
                </div>
              </div>
            </div>
            <div
              v-for="(item, i) in list"
              :key="i"
              class="text-lg font-black flex flex-col justify-between items-start"
              style="letter-spacing: 0.5px"
              :class="[item.label == 'Location' ? 'py-1' : 'py-4 ']"
            >
              <div
                class="w-full flex justify-between"
                :class="[
                  item.label == 'location'
                    ? 'flex-col items-start gap-4'
                    : 'items-center ',
                ]"
              >
                <div class="font-light text-sm flex items-center">
                  <div class="h-full px-2 pr-3 flex items-center">
                    <vs-icon
                      :icon-pack="icon[item.label.toLowerCase()].p"
                      :icon="icon[item.label.toLowerCase()].i"
                      style="font-size: 18px"
                    />
                  </div>
                  <div class="flex flex-col justify-center">
                    <div
                      class="capitalize"
                      :class="{
                        'font-bold text-base': item.label == 'heatmap',
                      }"
                    >
                      {{ item.label }}
                    </div>
                    <div v-if="item.caption" class="text-sm">
                      {{ item.caption }}
                    </div>
                  </div>
                </div>
                <span
                  class="text-sm"
                  :class="[
                    {
                      'text-primary cursor-pointer border-solid border-1 px-3 py-1 rounded-lg hover:bg-grey-light duration-2':
                        item.label == 'fuel' || item.label == 'temp',
                    },
                    {
                      'text-grey pointer-events-none':
                        (fetchFuelData && item.label == 'fuel') ||
                        (fetchFuelData && item.label == 'temp'),
                    },
                    { 'pl-3': item.label == 'location' },
                  ]"
                  @click="action(item.label)"
                >
                  {{
                    (fetchFuelData && item.label == 'fuel') ||
                    (fetchFuelData && item.label == 'temp')
                      ? `fetching data`
                      : item.data
                  }}
                </span>
                <!-- switch -->

                <vs-switch
                  v-model="showHeatmap"
                  size="small"
                  v-if="item.label == 'heatmap'"
                  color="success"
                >
                  <span slot="on">SHOW</span>
                  <span slot="off">HIDE</span>
                </vs-switch>
              </div>
              <div class="w-full mt-3 px-1" style="height: 1px">
                <div class="w-full h-full bg-grey-light"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="absolute left-0 top-0 w-full h-full flex justify-center items-center bg-white"
      v-if="!data || isLoading"
    >
      {{
        isLoading ? 'fetching data...' : `Please select a unit to view details`
      }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showHeatmapProp: {},
    geoPOIData: {},
    isLoading: {},
    data: {
      default: {
        unitId: 863719060385094,
        mileage: 13691,
        speed: '49kph',
        ignition: 'ON (05:30:19)',
        idling: 0,
        gps: 'YES',
        lat: 1.504245,
        lng: 103.60804,
        fuel: '253L (65%)',
        immobilizer: 'OFF',
        volt: '28.5V',
        fuel2: 0,
        i1: 0,
        address:
          'Second Link Expressway, Lima Kedai, Iskandar Puteri, Johor Bahru, Iskandar Malaysia, Johor, 81380, Malaysia',
        temp: '-',
        temp2: 0,
        temp3: 0,
        temp4: 0,
        heading: 164,
        create_time: '2023-12-07T04:34:38.000Z',
        ts: 1701923678,
        meta: null,
        assetName: 'MW - AKN6112',
        brand: 'teltonika',
        type: 'LORRY/TRUCK',
        assetId: 2324,
        lastUpdated: '07/12/2023 | 12:34:38',
        idlingStatus: '-',
        tempFuel: '253L (65%)',
        lowFuel: false,
        rotation: 164,
        tempInput: '-',
        tempTemp: '-',
        tempVolt: '28.5V',
        fuelPct: 65,
        input: '-',
        status: 'Moving',
        textColor: '#28C76F',
        stop: false,
      },
    },
  },
  computed: {
    widget() {
      if (!this.data) return [];
      else if (
        this.userInfo.username == 'mhbadmin' ||
        this.userInfo.username == 'ironwatch' ||
        this.userInfo.username == 'demowatch'
      ) {
        let arr = [
          { data: this.data.status, label: 'Status' },
          { data: this.data.gps, label: 'GPS' },
          //  { data: this.data.immobilizer, label: 'Immo' },
        ];
        return arr;
      } else {
        let arr = [
          { data: this.data.status, label: 'Status' },
          { data: this.data.gps, label: 'GPS' },
          { data: this.data.immobilizer, label: 'Immo' },
        ];
        return arr;
      }
    },
    list() {
      let list = [
        'ignition',
        ['idling', 'idlingStatus'],
        ['odometer', 'mileage'],
        'speed',
        'input',
        ['voltage', 'volt'],
        'temp',
  
        'fuel',
        ['location', 'address'],
      ];
      let arr = [];
      list.forEach((e) => {
        if (typeof e == 'string') {
          if (this.data[e] && this.data[e] != '-') {
            arr.push({ label: e, data: this.data[e] });
          }
        } else {
          if (this.data[e[1]] && this.data[e[1]] != '-') {
            arr.push({ label: e[0], data: this.data[e[1]] });
          }
        }
      });
      arr.push({ label: 'heatmap', caption: 'Travelled Today' });
      return arr;
    },
  },
  watch: {
    showHeatmap() {
      this.$emit('show-heatmap', this.showHeatmap);
    },
    showHeatmapProp() {
      if (this.showHeatmapProp != this.showHeatmap) {
        this.showHeatmap = this.showHeatmapProp;
      }
    },
  },
  data() {
    return {
      showHeatmap: false,
      icon: {
        ignition: { i: 'vpn_key' },
        idling: { i: 'icon-alert-octagon', p: 'feather' },
        odometer: { i: 'icon-aperture', p: 'feather' },
        speed: { i: 'speed' },
        input: { i: 'gavel' },
        voltage: { i: 'bolt' },
        temp: { p: 'feather', i: 'icon-thermometer' },
        humidity: { p: 'feather', i: 'icon-thermometer' },
        fuel: { i: 'local_gas_station' },
        status: { p: 'feather', i: 'icon-check-circle' },
        gps: { i: 'signal_cellular_4_bar' },
        immo: { i: 'lock' },
        location: { i: 'location_on' },
        heatmap: { i: 'route' },
      },
      fetchFuelData: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      dataSource: {
        data: null,
        navigator: {
          enabled: 0,
        },
        extensions: {
          customRangeSelector: {
            enabled: 0,
          },
        },
        chart: {
          animation: 0,
          palettecolors: 'FF0000,0000FF,008000',
          multicanvas: false,
          exportEnabled: 1,
          exportFileName: 'Fuel Chart',
        },
        caption: {
          text: 'Fuel Chart',
        },
        datamarker: null,
        yaxis: [
          {
            min: 0,
            plot: [
              {
                value: 'Fuel',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' litres',
            },
          },
          {
            plot: [
              {
                value: 'Odometer',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: '',
            },
          },
          {
            min: 0,
            max: 200,
            plot: [
              {
                value: 'Speed',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' kph',
            },
          },
        ],
      },
    };
  },
  methods: {
    async action(label) {
      if (label == 'fuel' || label == 'temp') {
        this.fetchFuelData = true;
        const { data, dataSchema } = await this.getChart(
          this.data.assetId,
          this.data.assetName,
          this.data.unitId,
          label == 'fuel' ? 'refuelChart' : 'temperatureChart',
        );
        if (label == 'temp') {
          this.dataSource = this.tempChartOptions();
        }
        this.$emit('get-chart', {
          data,
          dataSchema,
          dataSource: this.dataSource,
        });
        this.fetchFuelData = false;
      }
    },
    async getChart(assetId, assetName, unitId, url) {
      let response = await this.$http.post(
        `${url}/${assetId}/${this.userInfo.uid}/${unitId}`,
        {
          timeRange: 'daily',
          geoPOIData: this.geoPOIData,
        },
      );
      if (response.status == 200 && response.data.success) {
        const data = response.data.series;
        this.dataSource = this.fuelChartOptionsV1();
        this.dataSource.datamarker = response.data.datamarker;

        const dataSchema = response.data.dataSchema;
        if (response.data.type == 2) {
          this.dataSource.chart.palettecolors = 'FF0000,FFD700,0000FF,008000';
          this.dataSource.yaxis = this.fuelChartOptionsV2();
        }
        return { data, dataSchema };
      } else if (response.data.error) {
        console.log(response.data.error);
      } else {
        console.log(response);
      }
    },
    tempChartOptions() {
      let args = this.data;
      return {
        data: null,
        navigator: {
          enabled: 0,
        },
        extensions: {
          customRangeSelector: {
            enabled: 0,
          },
        },
        chart: {
          animation: 0,
          palettecolors: '800080,000000,0000FF,008000',
          multicanvas: false,
          exportEnabled: 1,
          exportFileName: `Temperature Chart -${args.assetName}`,
        },
        caption: {
          text: `Temperature Chart -${args.assetName}`,
        },
        datamarker: null,
        yaxis: [
          {
            min: -30,
            min: 100,
            plot: [
              {
                value: 'Temperature_1',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' °C',
            },
          },
          {
            min: -30,
            min: 100,
            plot: [
              {
                value: 'Temperature_2',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' °C',
            },
          },
          {
            min: -30,
            min: 100,
            plot: [
              {
                value: 'Temperature_3',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' °C',
            },
          },
          {
            min: -30,
            min: 100,
            plot: [
              {
                value: 'Temperature_4',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' °C',
            },
          },
          {
            min: -30,
            min: 100,
            plot: [
              {
                value: 'Preferred_Temperature',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' °C',
            },
          },
          {
            plot: [
              {
                value: 'Odometer',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: '',
            },
          },
          {
            min: 0,
            max: 200,
            plot: [
              {
                value: 'Speed',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' kph',
            },
          },
        ],
      };
    },
    fuelChartOptionsV1() {
      return {
        data: null,
        navigator: {
          enabled: 0,
        },
        extensions: {
          customRangeSelector: {
            enabled: 0,
          },
        },
        chart: {
          animation: 0,
          palettecolors: 'FF0000,0000FF,008000',
          multicanvas: false,
          exportEnabled: 1,
          exportFileName: 'Fuel Chart',
        },
        caption: {
          text: `Fuel Chart - ${this.data.assetName}`,
        },
        datamarker: null,
        yaxis: [
          {
            min: 0,
            plot: [
              {
                value: 'Fuel',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' litres',
            },
          },
          {
            plot: [
              {
                value: 'Odometer',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: '',
            },
          },
          {
            min: 0,
            max: 200,
            plot: [
              {
                value: 'Speed',
                connectnulldata: true,
                type: 'line',
              },
            ],
            format: {
              suffix: ' kph',
            },
          },
        ],
      };
    },
    fuelChartOptionsV2() {
      return [
        {
          min: 0,
          plot: [
            {
              value: 'Fuel',
              connectnulldata: true,
              type: 'line',
            },
          ],
          format: {
            suffix: ' litres',
          },
        },
        {
          min: 0,
          plot: [
            {
              value: 'Fuel2',
              connectnulldata: true,
              type: 'line',
            },
          ],
          format: {
            suffix: ' litres',
          },
        },
        {
          plot: [
            {
              value: 'Odometer',
              connectnulldata: true,
              type: 'line',
            },
          ],
          format: {
            suffix: '',
          },
        },
        {
          min: 0,
          max: 200,
          plot: [
            {
              value: 'Speed',
              connectnulldata: true,
              type: 'line',
            },
          ],
          format: {
            suffix: ' kph',
          },
        },
      ];
    },
    navigateToManageUnit() {
      const assetId = this.data.assetId;
      const assetName = this.data.assetName;
      const routeData = this.$router.resolve({
        name: 'map-single',
        params: { assetId, assetName },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style scoped></style>
